"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdCounterLabel = void 0;
var i18n_1 = require("../../localization/i18n");
var StringUtils_1 = require("../../utils/StringUtils");
var AdMessageLabel_1 = require("./AdMessageLabel");
/**
 * A label that displays an ad message for a single ad, or the index of the currently playing ad when multiple ads
 * are scheduled.
 *
 * @category Labels
 */
var AdCounterLabel = /** @class */ (function (_super) {
    __extends(AdCounterLabel, _super);
    function AdCounterLabel(config) {
        if (config === void 0) { config = {}; }
        var _this = _super.call(this, config) || this;
        _this.adBreakTrackerAdCountChangedHandler = function (_, adBreakTrackerEvent) {
            _this.setAdCounterFromAdBreakTracker(adBreakTrackerEvent.currentAdIndex, adBreakTrackerEvent.totalNumberOfAds);
        };
        _this.config = _this.mergeConfig(config, {
            cssClass: 'ui-label-ad-counter',
            text: i18n_1.i18n.getLocalizer('ad'),
            adCountOutOfTotal: i18n_1.i18n.getLocalizer('ads.adNumberOfTotal'),
        }, _this.config);
        return _this;
    }
    AdCounterLabel.prototype.configure = function (player, uimanager) {
        _super.prototype.configure.call(this, player, uimanager);
        this.player = player;
        this.adBreakTracker = uimanager.getConfig().adBreakTracker;
        this.adBreakTracker.onAdCountChanged.subscribe(this.adBreakTrackerAdCountChangedHandler);
        // An ad break may already be ongoing when configure is called, in this case the onAdCountChanged event was missed
        // and the label is set here
        if (this.adBreakTracker.currentAdIndex > 0 && this.adBreakTracker.totalNumberOfAds > 0) {
            this.setAdCounterFromAdBreakTracker(this.adBreakTracker.currentAdIndex, this.adBreakTracker.totalNumberOfAds);
        }
    };
    AdCounterLabel.prototype.release = function () {
        var _a;
        (_a = this.adBreakTracker) === null || _a === void 0 ? void 0 : _a.onAdCountChanged.unsubscribe(this.adBreakTrackerAdCountChangedHandler);
        this.adBreakTracker = undefined;
        this.player = undefined;
        _super.prototype.release.call(this);
    };
    AdCounterLabel.prototype.onLanguageChanged = function () {
        var _a, _b, _c, _d, _e, _f;
        if (((_a = this.adBreakTracker) === null || _a === void 0 ? void 0 : _a.currentAdIndex) > 0 || ((_d = (_c = (_b = this.player) === null || _b === void 0 ? void 0 : _b.ads) === null || _c === void 0 ? void 0 : _c.isLinearAdActive) === null || _d === void 0 ? void 0 : _d.call(_c))) {
            this.setAdCounterFromAdBreakTracker((_e = this.adBreakTracker) === null || _e === void 0 ? void 0 : _e.currentAdIndex, (_f = this.adBreakTracker) === null || _f === void 0 ? void 0 : _f.totalNumberOfAds);
        }
    };
    AdCounterLabel.prototype.getAdMessage = function (player, ad, currentAdIndex, totalNumberOfAds) {
        var _a, _b;
        var resolvedCurrentAdIndex = currentAdIndex !== null && currentAdIndex !== void 0 ? currentAdIndex : (_a = this.adBreakTracker) === null || _a === void 0 ? void 0 : _a.currentAdIndex;
        var resolvedTotalNumberOfAds = totalNumberOfAds !== null && totalNumberOfAds !== void 0 ? totalNumberOfAds : (_b = this.adBreakTracker) === null || _b === void 0 ? void 0 : _b.totalNumberOfAds;
        if (resolvedCurrentAdIndex > 0 && resolvedTotalNumberOfAds > 1) {
            return this.getAdCounterMessage(player, resolvedCurrentAdIndex, resolvedTotalNumberOfAds);
        }
        return _super.prototype.getAdMessage.call(this, player, ad);
    };
    AdCounterLabel.prototype.setAdCounterFromAdBreakTracker = function (currentAdIndex, totalNumberOfAds) {
        var _a, _b;
        if (currentAdIndex === 0 && totalNumberOfAds === 0) {
            // No ad break active and no subsequent ad breaks
            this.setText('');
            return;
        }
        this.setText(this.getAdMessage(this.player, (_b = (_a = this.player.ads) === null || _a === void 0 ? void 0 : _a.getActiveAd) === null || _b === void 0 ? void 0 : _b.call(_a), currentAdIndex, totalNumberOfAds));
    };
    AdCounterLabel.prototype.getAdCounterMessage = function (player, currentAdIndex, totalNumberOfAds) {
        return StringUtils_1.StringUtils.replaceAdMessagePlaceholders(i18n_1.i18n.performLocalization(this.config.adCountOutOfTotal), player, undefined, currentAdIndex, totalNumberOfAds);
    };
    return AdCounterLabel;
}(AdMessageLabel_1.AdMessageLabel));
exports.AdCounterLabel = AdCounterLabel;
